<style src="./ListItems.scss" lang="scss" scoped></style>
<template>
  <li
    class="itemrow">
    <ul class="itemcontainer">
      <column-item
        :info="item" />
      
      <column-suppliers
        :info="item"
        @select="selectedSupplier" />
    </ul>
  </li>
</template>

<script>
import ColumnItem from '../column-item/ColumnItem'
import ColumnSuppliers from '../column-suppliers/ColumnSuppliers'

export default {
  name: 'ListItems',
  components: {
    ColumnItem,
    ColumnSuppliers
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
    }
  },
  methods: {
    selectedSupplier (item) {
      this.$emit('suppliers-list', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-quote/components/list-items/ListItems.vue